import * as React from "react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "shared/utils/hooks/useRedux";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import { Box } from "@mui/material";
import styles from "features/health-ai/step-1/StepOne.module.css";
import healthAIBanner from "shared/assets/images/HealthBanner.png";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import CustomButton from "shared/custom-button/CustomButton";
import { colors } from "app/providers/theme/colors-type";
import {
  FormFieldsStepOne,
  programs,
} from "entities/health-ai/step-1/selector";
import { fetchDictionaries } from "entities/health-ai/step-1/action/fetch-step-one";
import Loader from "shared/loader/Loader";
import { updateField } from "entities/health-ai/step-1";

interface IPropsStepOne {
  windowWidth: number;
  handleNext: () => void;
}

export const StepOne: React.FC<IPropsStepOne> = ({
  windowWidth,
  handleNext,
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const risksArray = ["Медсоветник", "Психолог", "Юрист"];
  const { AgentSalesDataID } = useAppSelector(FormFieldsStepOne);
  const { isLoadingPrograms, Programs } = useAppSelector(programs);

  useEffect(() => {
    if (AgentSalesDataID) {
      dispatch(fetchDictionaries({ agentSalesDataID: AgentSalesDataID }));
    }
  }, [AgentSalesDataID]);
  const formatNumberWithSpaces = (number: number): string => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };
  useEffect(() => {
    if (Programs.length) {
      dispatch(updateField({ field: "ProgramId", value: Programs[0].ID }));
    }
  }, [Programs]);

  // console.log(Programs[0].ID);

  if (isLoadingPrograms) {
    return <Loader title="Пожалуйста подождите..." />;
  }

  return (
    <Box className={styles.desktopContainer}>
      <Box className={styles.infoBox}>
        <Box className={styles.leftBox}>
          <Box className={styles.info}>
            <h4>Ваше здоровье AI — поддержка, когда она нужна.</h4>
            <p>
              AI-консультации по здоровью, эмоциональному состоянию и
              юридическим правам
            </p>
          </Box>
          <Box className={styles.risksList}>
            <h4>Что входит</h4>
            {risksArray.map((item, index) => (
              <Box key={index} className={styles.riskBox}>
                <span className={styles.checkIcon}>
                  <CheckCircleIcon />
                </span>
                <p>{item}</p>
              </Box>
            ))}
          </Box>
        </Box>
        <Box className={styles.rightBoxImg}>
          <img src={healthAIBanner} alt="banner" />
        </Box>
      </Box>

      <Box className={styles.conditionsContainer}>
        <h4>Условия страхования</h4>
        <Box className={styles.conditionsBox}>
          {Programs.length && (
            <>
              <Box className={styles.conditionsItem}>
                <span className={styles.conditionsIcon}>
                  <ShieldOutlinedIcon />
                </span>
                <p>Страховая сумма</p>
                <span className={styles.discription}>
                  {formatNumberWithSpaces(Programs[0].InsuranceSum) || ""}{" "}
                  <CurrencyRubleIcon />
                </span>
                <span className={styles.discriptionInfo}>/чел</span>
              </Box>
              <Box className={styles.conditionsItem}>
                <span className={styles.conditionsIcon}>
                  <Diversity1OutlinedIcon />
                </span>
                <p>Страховая премия</p>
                <span className={styles.discription}>
                  {formatNumberWithSpaces(Programs[0].InsurancePremium) || ""}{" "}
                  <CurrencyRubleIcon />
                </span>
                <span className={styles.discriptionInfo}>/чел</span>
              </Box>{" "}
            </>
          )}

          <Box className={styles.conditionsItem}>
            <span className={styles.conditionsIcon}>
              <LocationOnOutlinedIcon />
            </span>
            <p>Территория страхования</p>
            <span className={styles.discription}>РФ</span>
          </Box>
          <Box className={styles.conditionsItem}>
            <span className={styles.conditionsIcon}>
              <CalendarMonthOutlinedIcon />
            </span>
            <p>Начало действия полиса</p>
            <span className={styles.discription}>на 15-й день</span>
            <span className={styles.discriptionInfo}>после оплаты</span>
          </Box>
        </Box>
      </Box>
      <Box className={styles.colorBox}>
        <span className={styles.icon}>
          <InfoIcon />
        </span>
        <p>
          Ответы AI-ассистента носят справочный характер и не заменяют очную
          консультацию врача, психолога или юриста.
        </p>
      </Box>
      <Box className={styles.btnBox}>
        <CustomButton
          title="Продолжить"
          handleClick={handleNext}
          textColor="white"
          backgroundColor={colors.primary}
          width="150px"
          gap="10px"
          borderRadius="4px"
          padding="3px"
        />
      </Box>
    </Box>
  );
};
